import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import userTransperent from "../../../Assets/user_transperent.png";
import "./InfluencerProfile.scss";
import {
  CrossIcon,
  FbIcon,
  InstaIcon,
  PenIcon,
  RejectedIcon,
  StarIcon,
  TwitterIcon,
  UtubeIcon,
  VerifiedIcon,
  WalletIcon,
} from "../../../Assets/svgIcons";
import { Col, Modal, Nav, Row, Tab } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import MyPromotions from "./MyPromotions/MyPromotions";
import MyRatings from "./MyRatings/MyRatings";
import MyFinancials from "./MyFinancials/MyFinancials";
import {
  getInfluencerInfo,
  getInfluencerProfile,
  getInfluencerRating,
  getInfluencerTotalEarning,
} from "../../../Services/prod/auth.service";
import { useAuth } from "../../../Contexts/auth.context";
import moment from "moment";
import Button, {
  BUTTON_TYPE_CLASSES,
} from "../../../components/button/button.component";
import { ErrorMessage, Field, Form, Formik } from "formik";

const InfluencerProfile = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState({});
  const [showReApply, setShowReApply] = useState(false);
  const [totalEarnings, setTotalEarnings] = useState(0);
  const [influencerInfo, setInfluencerInfo] = useState({});
  const [activeTab, setActiveTab] = useState("my-promotions");
  const [influencerRating, setInfluencerRating] = useState({});

  //   ************ INFLUENCER PROFILE API's {PROFILE , RATING , FINANCIALS} ************
  const getProfile = async () => {
    try {
      if (auth?.userId) {
        const [profileRes, getRatingRes, influencerRes, influencerInfo] =
          await Promise.all([
            getInfluencerProfile(auth?.userId),
            getInfluencerTotalEarning(),
            getInfluencerRating(1, 10, auth?.userId),
            getInfluencerInfo(),
          ]);
        if (
          profileRes?.status === 200 &&
          getRatingRes?.status === 200 &&
          influencerRes?.status === 200 &&
          influencerInfo?.status === 200
        ) {
          setProfileData(profileRes?.data);
          setTotalEarnings(getRatingRes?.data);
          setInfluencerRating(influencerRes?.data);
          setInfluencerInfo(influencerInfo?.data);
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  // ====================  SOCIAL MEDIA HANDLE FORMAT VALUES  ====================
  function formatNumber(value) {
    const formatter = new Intl.NumberFormat("en-IN");
    if (value >= 1_000_000_000) {
      return (
        formatter.format(
          (value / 1_000_000_000).toFixed(1).replace(/\.0$/, "")
        ) + "B"
      );
    } else if (value >= 1_000_000) {
      return (
        formatter.format((value / 1_000_000).toFixed(1).replace(/\.0$/, "")) +
        "M"
      );
    } else if (value >= 1_000) {
      return (
        formatter.format((value / 1_000).toFixed(1).replace(/\.0$/, "")) + "K"
      );
    }
    return formatter.format(value);
  }

  const socialMedia = [
    {
      icon: <UtubeIcon />,
      data: profileData?.influencer_socials
        ? profileData?.influencer_socials?.youtube_monthly_views
        : 0,
      name: "Monthly Views",
    },
    {
      icon: <TwitterIcon />,
      data: profileData?.influencer_socials
        ? profileData?.influencer_socials?.twitter_followers
        : 0,
      name: "Followers",
    },
    {
      icon: <InstaIcon />,
      data: profileData?.influencer_socials
        ? profileData?.influencer_socials?.instagram_followers
        : 0,
      name: "Followers",
    },
    {
      icon: <FbIcon />,
      data: profileData?.influencer_socials
        ? profileData?.influencer_socials?.facebook_followers
        : 0,
      name: "Followers",
    },
  ];
  // ====================  HANDLE TABS ====================
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
  };

  // ====================  INITIAL VALUES ====================
  const initialValues = {
    re_apply_comment: "",
  };

  //  ==================== INITIAL SCHEMA ====================
  const initialSchema = Yup.object({
    re_apply_comment: Yup.string()
      .required("Comment is Required")
      .min(5, "Comment must be at least 5 characters")
      .max(100, "Comment cannot be longer than 100 characters"),
  });

  //  ==================== FORMIK ON SUBMIT ====================
  const onSubmit = (values) => {
    try {
      navigate("/influncer-enrollment", { state: values?.re_apply_comment });
    } catch (error) {
      console.log(error, "error");
    }
  };
  return (
    <div className="influencer_profile_page">
      <h3>
        Influencer / <span>{profileData?.influencer_meta?.name}</span>{" "}
      </h3>
      {profileData?.influencer_request === "PENDING" && (
        <div className="review_status">Pending Review</div>
      )}
      <div className="profile_img">
        <img
          src={
            profileData?.influencer_meta?.image
              ? profileData?.influencer_meta?.image
              : userTransperent
          }
          alt="profile"
        />
        {profileData?.influencer_request === "APPROVED" && (
          <div className="profile_img_verified">
            <VerifiedIcon />
            <span>Verified</span>
            <p>
              Since{" "}
              {profileData?.influencer_verified_date
                ? moment(profileData?.influencer_verified_date).format(
                    "DD/MM/YYYY"
                  )
                : "Not Verify"}
            </p>
          </div>
        )}
        {profileData?.influencer_request === "REJECTED" && (
          <div className="profile_img_verified">
            <RejectedIcon />
            <span>Not Approved</span>
            <p>
              Since{" "}
              {profileData?.influencer_verified_date
                ? moment(profileData?.influencer_verified_date).format(
                    "DD/MM/YYYY"
                  )
                : "Not Verify"}
            </p>
          </div>
        )}
      </div>
      <div className="about_box">
        <h4>
          About Me
          {profileData?.influencer_request !== "REJECTED" && (
            <span
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/influncer-enrollment")}
            >
              <PenIcon />
            </span>
          )}
        </h4>
        <p className="desc_txt">{profileData?.influencer_meta?.description}</p>
        <div className="about_details">
          <Row>
            <Col md={4}>
              <div className="about_details_box social_network">
                <h5>
                  My Social Network{" "}
                  {profileData?.influencer_request !== "REJECTED" && (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/influncer-enrollment")}
                    >
                      <PenIcon />
                    </span>
                  )}
                </h5>
                <div className="social_network_links">
                  {socialMedia.map((item, index) => {
                    return (
                      <Link key={index} rel="noreferrer">
                        {item.icon}
                        <div>
                          {formatNumber(item?.data)}
                          <span>{item.name}</span>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div
                className="about_details_box rating"
                onClick={() => setActiveTab("my-rating")}
              >
                <h5>My Rating & Reviews</h5>
                <div className="rating_in">
                  <h6>{influencerRating?.average_rating || 0}</h6>
                  <div className="rating_in_stars">
                    <div className="rating_in_stars_original">
                      {Array.from({ length: 5 }).map((_, index) => {
                        const rating = influencerRating?.average_rating || 0;
                        const showRating = Math.floor(rating); // Number of fully filled stars
                        const fractionalPart = rating - showRating; // Fractional part of the rating
                        return (
                          <StarIcon
                            className={`active star_icon`}
                            style={{
                              clipPath: `inset(0 ${
                                index < showRating
                                  ? 0 // Fully filled
                                  : index === showRating // Partially filled star
                                  ? 100 - fractionalPart * 100
                                  : 100 // Completely unfilled
                              }% 0 0)`,
                            }}
                            key={index}
                          />
                        );
                      })}
                    </div>
                    <div className="rating_in_stars_copy">
                      {Array.from({ length: 5 }).map((_, index) => {
                        return <StarIcon className={`star_icon`} key={index} />;
                      })}
                    </div>
                  </div>
                  <p>{influencerRating?.count} ratings</p>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div
                className="about_details_box financial"
                onClick={() => setActiveTab("my-financials")}
              >
                <h5>Financial</h5>
                <WalletIcon />
                <p>Total earnings</p>
                <h6>
                  ${totalEarnings ? totalEarnings?.total_earnings : "0.00"}
                </h6>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {profileData?.influencer_request === "APPROVED" ? (
        <div className="influencer_profile_page_tabs">
          <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
            <Nav>
              <Nav.Item>
                <Nav.Link eventKey="my-promotions">My Promotions</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="my-rating">My Rating & Reviews</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="my-financials">Financials</Nav.Link>
              </Nav.Item>
            </Nav>
            <hr className="custom_hr" />
            <Tab.Content>
              <Tab.Pane eventKey="my-promotions">
                <MyPromotions activeTab={activeTab} />
              </Tab.Pane>
              <Tab.Pane eventKey="my-rating">
                <MyRatings activeTab={activeTab} />
              </Tab.Pane>
              <Tab.Pane eventKey="my-financials">
                <MyFinancials activeTab={activeTab} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      ) : (
        <div className="is_in_review">
          <hr className="custom_hr" />
          <h4>My Promotions</h4>
          <p className="desc_txt">
            {profileData?.influencer_request === "PENDING"
              ? "Your request to join as an influencer is being reviewed by MusicBull. Once approved, you will be able to start promoting MusicBull and the selected auctions."
              : profileData?.influencer_request === "REJECTED"
              ? "Your Profile is been Not Approved , Please Update your profile or contact admin."
              : ""}
          </p>
        </div>
      )}
      {profileData?.influencer_request === "REJECTED" && (
        <Button
          buttonType={BUTTON_TYPE_CLASSES.OutlinedButton}
          onClick={() => setShowReApply(true)}
        >
          Re-apply
        </Button>
      )}
      {showReApply && (
        <Modal
          show={showReApply}
          onHide={() => setShowReApply(false)}
          centered
          className="withdraw_modal_design"
        >
          <Formik
            initialValues={initialValues}
            validationSchema={initialSchema}
            onSubmit={onSubmit}
            validateOnChange
            enableReinitialize
          >
            {() => {
              return (
                <Form>
                  <Modal.Header>
                  <Modal.Title>Resubmit Application</Modal.Title>
                    <button
                      type="button"
                      className="cross_btn"
                      onClick={() => setShowReApply(false)}
                    >
                      <CrossIcon />
                    </button>
                    <p style={{ wordBreak: "break-all" }}>
                      <p style={{ fontWeight: "bold" }}>
                        MusicBull explanation for not approving your previous
                        request:
                      </p>{" "}
                      {influencerInfo?.user_comment}
                    </p>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="desc_box">
                      <p style={{ fontWeight: "bold" }}>
                        Influencer reply to MusicBull:{" "}
                        <span style={{ color: "red" }}>*</span>
                      </p>{" "}
                      <Field
                        type="text"
                        name="re_apply_comment"
                        className="custom_input"
                        placeholder="Add Comment"
                        autoComplete={false}
                      />
                      <ErrorMessage
                        name="re_apply_comment"
                        component="div"
                        className="error"
                      />
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="custom_btn next_btn">Submit</button>
                  </Modal.Footer>
                </Form>
              );
            }}
          </Formik>
        </Modal>
      )}
    </div>
  );
};

export default InfluencerProfile;
